import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Building2, Loader2, Smartphone } from "lucide-react";
import { toast } from "sonner";

export default function PersonnelLogin() {
  const navigate = useNavigate();
  const [tc, setTc] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/portal/login", { tc_no: tc, pin });
      toast.success("Giriş başarılı");
      navigate("/portal");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-6">
      <div className="w-full max-w-sm fade-up">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-11 h-11 rounded-xl bg-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-600/30">
            <Smartphone className="w-6 h-6 text-white" />
          </div>
          <div>
            <div className="font-heading font-extrabold text-2xl tracking-tight text-white leading-none">VİLAYET</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1">Personel Portalı</div>
          </div>
        </div>

        <h1 className="font-heading text-2xl font-bold text-white tracking-tight text-center">Maaş & Devamsızlık Sorgulama</h1>
        <p className="text-slate-400 text-sm mt-2 text-center">T.C. Kimlik No ve PIN kodunuzla giriş yapın.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest font-semibold text-slate-400">T.C. Kimlik No</label>
            <input
              data-testid="portal-tc-input"
              inputMode="numeric"
              maxLength={11}
              required
              value={tc}
              onChange={(e) => setTc(e.target.value.replace(/\D/g, ""))}
              className="mt-2 w-full bg-slate-900/80 border border-slate-700 rounded-xl px-4 py-3.5 text-white text-base outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition"
              placeholder="11 haneli T.C. No"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-semibold text-slate-400">PIN Kodu</label>
            <input
              data-testid="portal-pin-input"
              type="password"
              inputMode="numeric"
              required
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              className="mt-2 w-full bg-slate-900/80 border border-slate-700 rounded-xl px-4 py-3.5 text-white text-base outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition"
              placeholder="Yöneticinizden aldığınız PIN"
            />
          </div>

          {error && (
            <div data-testid="portal-login-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            data-testid="portal-login-button"
            type="submit"
            disabled={loading}
            className="w-full py-3.5 rounded-xl bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 text-white font-semibold text-base transition-colors flex items-center justify-center gap-2 shadow-lg shadow-emerald-600/25"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/giris" className="text-xs text-slate-500 hover:text-slate-300 flex items-center justify-center gap-1">
            <Building2 className="w-3 h-3" /> Yönetici girişi
          </Link>
        </div>
      </div>
    </div>
  );
}
